import { FileBulkActionRequest } from './../../shared/models/file-bulk-action-request';
import { FileAssignComponentsRequest } from './../../shared/models/file-assign-components-request';
import { FileDirectory } from './../../shared/models/file-directory';
import * as _ from 'underscore';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ViewChild, OnChanges, SimpleChanges
} from '@angular/core';
import { PropertyFile, FolderActionRequest, FileActionRequest } from '../../shared/models';
import { ModalComponent } from 'app/internal/shared/components/modal';
import { FiscalYear } from 'app/internal/shared/models';
import { SelectFolderModalComponent } from '../select-folder-modal';
import { FileAssignComponentModalComponent } from '../file-assign-component-modal';
import { DxPopupTypes } from 'devextreme-angular/ui/popup';

@Component({
  selector: 'sp-file-list-display',
  templateUrl: './file-list-display.component.html',
  styleUrls: ['./file-list-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FileListDisplayComponent implements OnChanges {
  @ViewChild('selectFolder', { static: true }) public selectFolderModal: SelectFolderModalComponent;
  @ViewChild('assignComponents', { static: true }) public assignComponentsModal: FileAssignComponentModalComponent;

  @ViewChild('renameFolder', { static: true }) public renameFolderModal: ModalComponent;
  @ViewChild('deleteFolder', { static: true }) public deleteFolderModal: ModalComponent;
  @ViewChild('renameFile', { static: true }) public renameFileModal: ModalComponent;
  @ViewChild('deleteFile', { static: true }) public deleteFileModal: ModalComponent;
  @ViewChild('deleteBulk', { static: true }) public deleteBulkModal: ModalComponent;

  @Input() directoryInfo: FileDirectory;
  @Input() folderStructure: FileDirectory;
  @Input() propertyId: string;
  @Input() fiscalYear: FiscalYear;

  @Output() folderSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() folderRenamed: EventEmitter<FolderActionRequest> = new EventEmitter<FolderActionRequest>();
  @Output() folderMoved: EventEmitter<FolderActionRequest> = new EventEmitter<FolderActionRequest>();
  @Output() folderDeleted: EventEmitter<FolderActionRequest> = new EventEmitter<FolderActionRequest>();

  @Output() fileRenamed: EventEmitter<FileActionRequest> = new EventEmitter<FileActionRequest>();
  @Output() fileMoved: EventEmitter<FileActionRequest> = new EventEmitter<FileActionRequest>();
  @Output() fileDeleted: EventEmitter<FileActionRequest> = new EventEmitter<FileActionRequest>();
  @Output() downloadFile: EventEmitter<FileActionRequest> = new EventEmitter<FileActionRequest>();
  @Output() assignComponents: EventEmitter<FileAssignComponentsRequest> = new EventEmitter<FileAssignComponentsRequest>();
  @Output() moveBulk: EventEmitter<FileBulkActionRequest> = new EventEmitter<FileBulkActionRequest>();
  @Output() downloadBulk: EventEmitter<FileBulkActionRequest> = new EventEmitter<FileBulkActionRequest>();
  @Output() deleteBulk: EventEmitter<FileBulkActionRequest> = new EventEmitter<FileBulkActionRequest>();

  folderForAction: FileDirectory;
  renameFolderName: string;

  fileForAction: PropertyFile;
  renameFileName: string;
  fileToView: PropertyFile;

  moveItemName: string;
  moveExcludeFolderIds: string[];
  assignComponentFiles: PropertyFile[];

  isBulkAction = false;
  selectedFileIds = [];
  selectedFolderIds = [];

  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['directoryInfo'] && this.directoryInfo) {
      this.directoryInfo.files = _.sortBy(this.directoryInfo.files, 'fileName');
      this.directoryInfo.folders = _.sortBy(this.directoryInfo.folders, 'folderName');
      this.selectedFileIds = [];
      this.selectedFolderIds = [];
    }
  }

  backToParentFolder() {
    this.folderSelected.emit(this.directoryInfo.parentFolder.folderId);
  }

  onFolderSelected(folderId: string) {
    if (this.directoryInfo.folderId !== folderId) {
      this.folderSelected.emit(folderId);
    }
  }

  onDownloadFile(file: PropertyFile) {
    const request = new FileActionRequest(this.propertyId, file.propertyFileId, null, null);
    this.downloadFile.emit(request);
  }

  showRenameFolderModal(folder: FileDirectory) {
    this.folderForAction = folder;
    this.renameFolderName = folder.folderName;
    this.renameFolderModal.show();
  }

  onRenameFolder() {
    const request = new FolderActionRequest(this.propertyId, this.folderForAction.folderId, this.renameFolderName, null);
    this.folderRenamed.emit(request);
  }

  showMoveFolderModal(folder: FileDirectory) {
    this.folderForAction = folder;
    this.moveItemName = folder.folderName;
    this.moveExcludeFolderIds = [folder.folderId];
    this.selectFolderModal.show();
  }

  onFolderSelectedForMove(selectedFolderId: string) {
    if (this.isBulkAction) {
      const folderIds = this.excludeSystemFolderIdsFromSelection(this.selectedFolderIds);
      const request = new FileBulkActionRequest(this.propertyId, this.selectedFileIds, folderIds);
      request.moveToFolderId = selectedFolderId;
      this.moveBulk.emit(request);
    } else if (this.folderForAction != null) {
      const request = new FolderActionRequest(this.propertyId, this.folderForAction.folderId, null, selectedFolderId);
      this.folderMoved.emit(request);
    } else if (this.fileForAction != null) {
      const request = new FileActionRequest(this.propertyId, this.fileForAction.propertyFileId, null, selectedFolderId);
      this.fileMoved.emit(request);
    }

    this.folderForAction = null;
    this.fileForAction = null;
    this.moveItemName = null;
    this.moveExcludeFolderIds = null;
    this.isBulkAction = false;
  }

  showDeleteFolderModal(folder: FileDirectory) {
    this.folderForAction = folder;
    this.deleteFolderModal.show();
  }

  onDeleteFolder() {
    const request = new FolderActionRequest(this.propertyId, this.folderForAction.folderId, null, null);
    this.folderDeleted.emit(request);
  }


  /*********** FILE ACTIONS *****************/
  showRenameFileModal(file: PropertyFile) {
    this.fileForAction = file;
    this.renameFileName = file.fileName;
    this.renameFileModal.show();
  }

  onRenameFile() {
    const request = new FileActionRequest(this.propertyId, this.fileForAction.propertyFileId, this.renameFileName, null);
    this.fileRenamed.emit(request);
  }

  showMoveFileModal(file: PropertyFile) {
    this.fileForAction = file;
    this.moveItemName = file.fileName;
    this.moveExcludeFolderIds = null;
    this.selectFolderModal.show();
  }

  showDeleteFileModal(file: PropertyFile) {
    this.fileForAction = file;
    this.deleteFileModal.show();
  }

  onDeleteFile() {
    const request = new FileActionRequest(this.propertyId, this.fileForAction.propertyFileId, null, null);
    this.fileDeleted.emit(request);
  }

  showAssignComponentsModal(file: PropertyFile) {
    this.fileForAction = file;
    this.assignComponentFiles = [file];
    this.assignComponentsModal.show();
  }

  onAssignComponentsConfirm(request: FileAssignComponentsRequest) {
    this.assignComponents.emit(request);
  }


  /*********** BULK FILE ACTIONS *****************/
  getSelectedCount() {
    return this.selectedFileIds.length + this.selectedFolderIds.length;
  }

  isFolderSelected(folder: FileDirectory) {
    const existingIndex = this.selectedFolderIds.indexOf(folder.folderId);

    return existingIndex >= 0;
  }

  isFileSelected(file: PropertyFile) {
    const existingIndex = this.selectedFileIds.indexOf(file.propertyFileId);

    return existingIndex >= 0;
  }

  toggleFolderSelection(folder: FileDirectory) {
    if (folder.isSystemFolder === true) {
      return;
    }
    const existingIndex = this.selectedFolderIds.indexOf(folder.folderId);

    // is in list, so remove
    if (existingIndex >= 0) {
      this.selectedFolderIds.splice(existingIndex, 1);
    } else {
      this.selectedFolderIds.push(folder.folderId);
    }
  }

  toggleFileSelection(file: PropertyFile) {
    const existingIndex = this.selectedFileIds.indexOf(file.propertyFileId);

    // is in list, so remove
    if (existingIndex >= 0) {
      this.selectedFileIds.splice(existingIndex, 1);
    } else {
      this.selectedFileIds.push(file.propertyFileId);
    }
  }

  toggleAllSelection(select: boolean) {
    this.toggleAllFolderSelection(select);
    this.toggleAllFileSelection(select);
  }

  toggleAllFolderSelection(select: boolean) {
    if (select === true && this.directoryInfo.folders) {
      this.selectedFolderIds = this.directoryInfo.folders
        .filter((p) => p.isSystemFolder !== true)
        .map((p) => p.folderId);
    } else {
      this.selectedFolderIds = [];
    }
  }

  toggleAllFileSelection(select: boolean) {
    if (select === true && this.directoryInfo.files) {
      this.selectedFileIds = this.directoryInfo.files.map((p) => p.propertyFileId);
    } else {
      this.selectedFileIds = [];
    }
  }

  showMoveBulkModal() {
    this.isBulkAction = true;
    this.moveItemName = this.getSelectedCount() + ' selected items';
    this.moveExcludeFolderIds = this.excludeSystemFolderIdsFromSelection(this.selectedFolderIds);
    this.selectFolderModal.show();
  }

  showAssignComponentsBulkModal() {
    this.isBulkAction = true;
    this.assignComponentFiles = this.directoryInfo.files.filter((x) => this.selectedFileIds.indexOf(x.propertyFileId) >= 0);
    this.assignComponentsModal.show();
  }

  showDeleteBulkModal() {
    this.isBulkAction = true;
    this.deleteBulkModal.show();
  }

  onDeleteBulk() {
    const folderIds = this.excludeSystemFolderIdsFromSelection(this.selectedFolderIds);
    const request = new FileBulkActionRequest(this.propertyId, this.selectedFileIds, folderIds);
    this.deleteBulk.emit(request);
  }

  onDownloadBulk() {
    const request = new FileBulkActionRequest(this.propertyId, this.selectedFileIds, this.selectedFolderIds);
    this.downloadBulk.emit(request);
  }

  onPopupShowing(e: DxPopupTypes.ShowingEvent) {
    if (this.getSelectedCount() > 0) {
      e.cancel = true;
    }
  }

  getFolderFileCount(folder: FileDirectory): number {
    // Non-recursive count: only direct files in the folder
    return folder?.fileCount ?? 0;
  }

  getFolderCount(folder: FileDirectory): number {
    // Non-recursive count: only direct subfolders in the folder
    return folder?.folderCount ?? 0;
  }

  getTotalItemsCount(folder: FileDirectory): number {
    // Total items: folders + files (non-recursive - direct items only)
    return this.getFolderCount(folder) + this.getFolderFileCount(folder);
  }

  /** Rename / move / delete are blocked for the server-managed Projects root only. */
  folderRowActionsEnabled(folder: FileDirectory): boolean {
    return folder?.isSystemFolder !== true;
  }

  private excludeSystemFolderIdsFromSelection(folderIds: string[]): string[] {
    const system = new Set(
      (this.directoryInfo?.folders ?? [])
        .filter((f) => f.isSystemFolder === true)
        .map((f) => f.folderId)
    );
    return folderIds.filter((id) => !system.has(id));
  }

  getFolderCountDisplay(folder: FileDirectory): string {
    const totalItems = this.getTotalItemsCount(folder);
    const fileCount = this.getFolderFileCount(folder);
    const folderCount = this.getFolderCount(folder);
    
    // If all items are files, just show file count to avoid redundancy (e.g., "3 files" instead of "3 items, 3 files")
    if (totalItems === fileCount && fileCount > 0) {
      const fileText = fileCount === 1 ? 'file' : 'files';
      return `${fileCount} ${fileText}`;
    }
    
    // If there are both folders and files, show both counts
    if (folderCount > 0 && fileCount > 0) {
      const folderText = folderCount === 1 ? 'folder' : 'folders';
      const fileText = fileCount === 1 ? 'file' : 'files';
      return `${folderCount} ${folderText}, ${fileCount} ${fileText}`;
    }

    //If only folders, show folder count
    if (totalItems === folderCount && folderCount > 0) {
      const folderText = folderCount === 1 ? 'folder' : 'folders';
      return `${folderCount} ${folderText}`;
    }
    
    // catch all - show total items count
    const itemText = totalItems === 1 ? 'item' : 'items';
    return `${totalItems} ${itemText}`;
  }
}
